import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css';

const relaxationZoneImages = [
  { id: 1, thumbnail: '../images/interior7/ОТДЫХ_РЕЛАКСАЦИЯ.png', fullImage: '../images/interior7/ОТДЫХ_РЕЛАКСАЦИЯ.png' },
  { id: 2, thumbnail: '../images/interior7/МЯГКАЯ_ЗОНА_1.png', fullImage: '../images/interior7/МЯГКАЯ_ЗОНА_1.png' },
  { id: 3, thumbnail: '../images/interior7/ОТДЫХ_РЕЛАКСАЦИЯ_1.png', fullImage: '../images/interior7/ОТДЫХ_РЕЛАКСАЦИЯ_1.png' },
  { id: 4, thumbnail: '../images/interior7/ПРИНТЕРНАЯ.png', fullImage: '../images/interior7/ПРИНТЕРНАЯ.png' },
  { id: 5, thumbnail: '../images/interior7/ПРИНТЕРНАЯ_1.png', fullImage: '../images/interior7/ПРИНТЕРНАЯ_1.png' },
  { id: 6, thumbnail: '../images/interior7/ПРИНТЕРНАЯ_2.png', fullImage: '../images/interior7/ПРИНТЕРНАЯ_2.png' },
  // Add more images as needed
];

function RelaxationZone() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/interior-designs');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : relaxationZoneImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < relaxationZoneImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>
      <div className="project-detail-grid">
        {relaxationZoneImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Relaxation Zone Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ИНТЕРЬЕРЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={relaxationZoneImages[selectedImageIndex].fullImage} alt={`Relaxation Zone Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default RelaxationZone; 